// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useState, useContext, useEffect, useMemo} from 'react';
// @ts-ignore
import {get_client_hints} from '/util/client_hints.js';
import etask from 'zetask';
import {perr} from 'hola_pub_util';
import {guess} from 'zuser_agent';
import {global_client_hints, i_client_hints} from './client_hints_global';

interface i_ch_props {
    client_hints: i_client_hints;
    children: JSX.Element;
}

const Client_hints_context = React.createContext<i_client_hints>({});
export const Client_hints_provider = ({children, client_hints}: i_ch_props)=>{
    const [ch, set_ch] = useState<i_client_hints>(client_hints);
    useMemo(()=>{
        global_client_hints.value = client_hints;
    }, []);
    useEffect(()=>{
        etask(function*(){
            // @ts-ignore
            const ua_data = navigator.userAgentData;
            if (ua_data && ua_data.getHighEntropyValues)
            {
                const hints = yield ua_data.getHighEntropyValues([
                    'platform', 'platformVersion', 'mobile',
                ]);
                hints.platform_version = hints.platformVersion;
                const new_ch = get_client_hints({
                    hints,
                    ua: navigator.userAgent,
                });
                if (ch?.platform?.os=='windows' &&
                    ch?.platform?.version!=new_ch?.platform?.version)
                {
                    perr({id: 'www_detect_platform_from_hints', info: {
                        old: `${ch?.platform?.os}${ch?.platform?.version}`,
                        new: `${new_ch?.platform?.os}${
                            new_ch?.platform?.version
                        }`,
                    }});
                }
                if (ch?.platform?.os=='windows'
                    && new_ch?.platform?.version=='7')
                {
                    const os = guess();
                    if (os.version=='10.0')
                    {
                        perr({id: 'www_detect_win7_but_was10', info: {
                            old: `${ch?.platform?.os}${ch?.platform?.version}`,
                            new: `${new_ch?.platform?.os}${
                                new_ch?.platform?.version
                            }`,
                        }});
                    }
                }
                global_client_hints.value = new_ch;
                set_ch(new_ch);
            }
        });
    }, []);
    return <Client_hints_context.Provider value={ch}>
      {children}
    </Client_hints_context.Provider>;
};

export const use_client_hints = ()=>useContext(Client_hints_context);
